import apiClient from "services/apiClient";

async function updateObserver(id: number, body: any) {
    const res = await apiClient.put(`/admin/imports/${id}/update-observer`, body);
    return res.data;
}

export default updateObserver;
